import mixpanel from 'mixpanel-browser';
mixpanel.init('54a9978a6b68a8c46a959f6d6347fa0f', {
  debug: true,
  track_pageview: false,
  persistence: 'localStorage',
  autocapture: {
    click: true,
    input: true,
    scroll: false,
    submit: true,
    capture_text_content: false,
  },
});

export const Mixpanel = mixpanel;
